var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-npc-container"},[_c('b-tabs',{attrs:{"content-class":"mt-0","fill":""}},_vm._l((_vm.multiCh),function(ch,index){return _c('b-tab',{key:ch,attrs:{"title":ch}},[_c('iframe',{staticClass:"npc-iframe",attrs:{"src":_vm.iframeSrc(ch, index),"allowfullscreen":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }